import { startCase } from "lodash";
import { IStoragePathItemData } from "../../../dataingestion/types/IStoragePathItemData";
import { PRODUCT_TYPE_LOOKUP } from "../../../lookup/Consts";
import { getLookupDefault } from "../../../lookup/services/LookupHelpers";
import { ILookupDictionary } from "../../../lookup/types/ILookupDictionary";
import { IDraftSetListSearchResult } from "../../../membersportal/types/IDraftSetListSearchResult";
import { IAttachedFile } from "../../../redux/types/IAttachedFile";
import { IUsageGroupComment } from "../../../redux/types/IUsageGroupComment";
import { IUsageGroupState } from "../../../redux/types/IUsageGroupState";
import { IMatchProductsSearchQuery } from "../../../repertoire/types/usageTypes/IMatchProductsSearchQuery";
import { BOOLEAN_READONLY_INPUT, CHECKBOX_INPUT, DATE_INPUT, DEFINITE_MATCH, EMPTY_STRING_VALUE, REPERTOIRE, USAGETOPRODUCT, USAGETOPRODUCT_NO_SPACES, USAGETOWORK, USAGETOWORK_NO_SPACES } from "../../Consts";
import { IArtist } from "../../types/IArtist";
import { IProductSearchResult } from "../../types/IProductSearchResult";
import { IWorksSearchResult } from "../../types/IWorksSearchResult";
import { IMatchingProductsRowData } from "../../types/usageTypes/IMatchingProductsRowData";
import { IMatchingWorksRowData } from "../../types/usageTypes/IMatchingWorksRowData";
import { IMatchWorksSearchQuery } from "../../types/usageTypes/IMatchWorksSearchQuery";
import { IMoreDates } from "../../types/usageTypes/IMoreDates";
import { IPerformanceNumber } from "../../types/usageTypes/IPerformanceNumber";
import { IUsage } from "../../types/usageTypes/IUsage";
import { IUsageDetails } from "../../types/usageTypes/IUsageDetails";
import { IUsageDetailsRowData } from "../../types/usageTypes/IUsageDetailsRowData";
import { IUsageGroup } from "../../types/usageTypes/IUsageGroup";
import { IUsageGroupSetListAdditional } from "../../types/usageTypes/IUsageGroupSetListAdditional";
import { IUsageMatch } from "../../types/usageTypes/IUsageMatch";
import { IUsageProductDetails } from "../../types/usageTypes/IUsageProductDetails";
import { IUsageRowData } from "../../types/usageTypes/IUsageRowData";
import { IUsageSearch } from "../../types/usageTypes/IUsageSearch";
import { IUsageDetailsAdjustmentsDataItem } from "../../usage/components/usageRowDropdown/UsageRowDropdown";
import { UsagePoolDetailsMapper } from "../UsagePoolDetailsMapper";
import { UsageSearchRequests } from "./UsageSearchRequests";
import { ILivePerformanceResult } from "../../../membersportal/types/ILivePerformancesSearchResult";
import { MEMBERS_PORTAL } from "../../../accounts/Consts";


export class UsageDetailsMapper {
    public static getNewUsageFileName(poolCode: string, usageDate: string): string {
        const normalizedPoolCode = poolCode?.trim() || "UnassignedPool";
        const parsedUsageDate = new Date(usageDate);
        const formattedUsageDate = Number.isNaN(parsedUsageDate.getTime())
            ? "UnknownDate"
            : parsedUsageDate.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");

        return `ME-${normalizedPoolCode}-${formattedUsageDate}.txt`;
    }

    public static mapUsageToState(usageGroup: IUsageGroup, workMatches?: IMatchingWorksRowData[], productMatches?: IMatchingProductsRowData[], isMembersPortal?: boolean, reGroupIds?: Number[], originalUsageGroupID?: string, lookups?: ILookupDictionary): IUsageGroupState {
        if (!usageGroup)
            return null;

        const {
            id,
            fullTitle,
            fullContributor,
            fullPerformer,
            distributionCode,
            poolCode,
            sourceMajor,
            sourceMinor,
            usageType,
            productType,
            matchStatus,
            allocationStatus,
            isLicenseAllocated,
            isDeleted,
            allocations,
            remittingSocietyWorkCode,
            fileName,
            dateLoaded,
            workflows,
            totalWeightString,
            attachedFiles,
            location,
            setListAdditional,
            moreDates,
            approvalStatus,
            enableApprovalStatusEdit,
            venueDetails,
            sourceIP,
            qaStatus,
            rejectReason,
            licenses,
            usagePool,
            comments,
            setListArtist,
            customerVenues,
            catOne,
            catTwo,
        } = usageGroup;

        let usagesValues = UsageDetailsMapper.mapUsageGroupToUsages(usageGroup, reGroupIds, lookups);
        const updatedMoreDates: IMoreDates[] = [];
        let setList: IDraftSetListSearchResult = null;

        if (isMembersPortal) {
            if (usagesValues.length > 1) {
                usagesValues.slice(1).map((element) => {
                    if (!element?.isDeleted) {
                        const startDate = element.programStartDate?.value?.split("T")[0];
                        const endDate = element.programEndDate?.value?.split("T")[0];
                        const spansTwoDates = !!startDate && !!endDate && startDate !== endDate;

                        let value: IMoreDates = {
                            id: element?.guid?.value,
                            programStartDate: element.programStartDate ? element.programStartDate : null,
                            programEndDate: element.programEndDate ? element.programEndDate : null,
                            usageDate: element.usageDate,
                            usageEndDate: {
                                ...element.usageDate,
                                value: endDate || startDate
                            },
                            spansTwoDates: {
                                value: spansTwoDates,
                                inputType: BOOLEAN_READONLY_INPUT
                            }
                        }
                        updatedMoreDates.push(value)
                    }
                })
            }

            if (usageGroup.matches?.length > 0 && usageGroup.matches[0].productData) {
                const match = usageGroup.matches[0];
                const productData = match.productData;
                const productNumbers = productData.number ?? [productData.id1, productData.id2].filter(Boolean);

                setList = {
                    title: productData.title,
                    productCoreID: productData.productCoreID,
                    dataSource: null,
                    setListID: productData.productCoreID.toString(),
                    productStatus: productData.status,
                    type: productData.type,
                    id1: productData.id1,
                    id2: productData.id2,
                    number: productNumbers,
                    contributor: productData.contributor,
                    artist: productData.artist,
                    source: productData.source
                };

                if (!productMatches || productMatches.length === 0) {
                    productMatches = [{
                        status: productData.status,
                        matchType: match.matchType,
                        id1: productData.id1,
                        id2: productData.id2,
                        artist: productData.artist,
                        contributor: productData.contributor,
                        productCoreID: productData.productCoreID,
                        source: startCase(match.matchSource),
                        title: productData.title,
                        episode: productData.episode,
                        type: productData.type,
                        number: productNumbers,
                        productionType: productData.productionType,
                        musicDuration: productData.musicDuration,
                        createMatchHistory: match.createMatchHistory ?? null,
                        yearOfProduction: productData.yearOfProduction,
                        worksCount: productData.worksCount
                    }];
                }
            }
        }
        const usageGroupState: IUsageGroupState = {
            id: (reGroupIds && reGroupIds.length > 0) ? null : id,
            fullTitle,
            fullContributor,
            fullPerformer,
            distributionCode,
            poolCode,
            sourceMajor,
            sourceMinor,
            usageType,
            productType,
            matchStatus,
            allocationStatus,
            isLicenseAllocated,
            isDeleted,
            allocations: ((reGroupIds && reGroupIds.length > 0) ? [] : allocations) ?? [],
            remittingSocietyWorkCode,
            fileName,
            totalWeight: ((reGroupIds && reGroupIds.length > 0) ? null : totalWeightString),
            dateLoaded: (reGroupIds && reGroupIds.length > 0) ? null : dateLoaded,
            usages: usagesValues,
            matchingWorks: workMatches || UsageDetailsMapper.mapUsageGroupToMatchingWorks(usageGroup, usageType),
            matchingProducts: productMatches || UsageDetailsMapper.mapUsageGroupToMatchingProducts(usageGroup, usageType),
            matchingLicenses: licenses,
            workflows,
            files: UsageDetailsMapper.mapAttachmentsToFileState(attachedFiles),
            location,
            setListAdditional,
            venueDetails,
            moreDates: updatedMoreDates ? updatedMoreDates : moreDates,
            approvalStatus,
            enableApprovalStatusEdit,
            sourceIP,
            livePerformanceSetList: setList,
            qaStatus,
            rejectReason,
            originalUsageGroupID,
            usagePool: UsagePoolDetailsMapper.mapPoolToState(usagePool),
            comments: UsageDetailsMapper.mapCallToComments(comments),
            setListArtist: UsageDetailsMapper.mapArtistsToState(setListArtist),
            customerVenues: customerVenues,
            catOne,
            catTwo,
            createMatchHistory: usageGroup.createMatchHistory
        }

        return usageGroupState;
    }

    public static mapStateToSetListAdditional(setListAdditional: IUsageGroupSetListAdditional, setListArtist: IArtist) {
        return {
            ...setListAdditional,
            artists: setListArtist,
        }
    }


    public static mapStateUsageGroup(state: IUsageGroupState, isMembersPortal?: boolean): IUsageGroup {
        if (!state)
            return null;

        const {
            id,
            fullTitle,
            fullContributor,
            fullPerformer,
            distributionCode,
            poolCode,
            sourceMajor,
            sourceMinor,
            usageType,
            productType,
            matchStatus,
            allocationStatus,
            allocations,
            isDeleted,
            remittingSocietyWorkCode,
            fileName,
            totalWeight,
            dateLoaded,
            workflows,
            files,
            location,
            setListAdditional,
            venueDetails,
            moreDates,
            approvalStatus,
            sourceIP,
            qaStatus,
            rejectReason,
            usagePool,
            catOne,
            catTwo,
            matchingLicenses,
            comments,
            setListArtist,
            createMatchHistory,
            
        } = state;

        let commentList = UsageDetailsMapper.mapStateToComments(comments);
        let usageList = UsageDetailsMapper.mapStateToUsages(state);

        if (isMembersPortal && moreDates.length >= 1) {
            moreDates.map((element) => {

                if (!element?.id) {
                    const updatedUsagesObj: IUsage = {
                        id: "",
                        bundle: "",
                        bundleRetailPriceExTax: "",
                        bundleTracks: "",
                        bundleTracksPayable: "",
                        carrierType: "",
                        cartNumber: "",
                        count: 1,
                        distributionMethod: "",
                        durationPerPlay: 0,
                        inDispute: "",
                        musicDuration: null,
                        programEndDate: element.programEndDate.value,
                        programName: "",
                        programStartDate: element.programStartDate.value,
                        usageDate: element.usageDate.value,
                        weight: 1,
                        isDeleted: false,
                        usageDetails: [],
                        names: [],
                        performanceNumbers: [],
                        performers: [],
                        contributors: [],
                        productDetails: null,
                        publisher: "",
                        receivedAmount: "",
                        recordLabel: "",
                        recordName: "",
                        recordingDate: "",
                        productionCountry: "",
                        recordingType: "",
                        releaseDate: "",
                        royaltyAmount: "",
                        royaltyAmountPerPerformance: "",
                        timing: "",
                        trackNumber: "",
                        unitRetailPrice: "",
                        unitRetailPriceExVat: "",
                        exploitationTerritoryAbbreviatedName: "",
                        exploitationSourceIdentifier: "",
                        exploitationSourceName: ""
                    }
                    usageList.push(updatedUsagesObj);
                }
            })
        }
        const normalizedUsageType = usageType?.replace(/\s+/g, "").toLowerCase();
        const persistedUsageType = normalizedUsageType === USAGETOWORK_NO_SPACES.toLowerCase()
            ? USAGETOWORK_NO_SPACES
            : normalizedUsageType === USAGETOPRODUCT_NO_SPACES.toLowerCase()
                ? USAGETOPRODUCT_NO_SPACES
                : usageType?.replace(/\s+/g, "");
        const usageGroup: IUsageGroup = {
            id,
            fullTitle,
            fullContributor,
            fullPerformer,
            distributionCode,
            poolCode,
            sourceMajor,
            sourceMinor,
            usageType: isMembersPortal ? USAGETOPRODUCT_NO_SPACES : persistedUsageType,
            productType,
            matchStatus,
            allocationStatus,
            allocations,
            isDeleted,
            remittingSocietyWorkCode,
            fileName,
            dateLoaded,
            totalWeight: isNaN(parseFloat(totalWeight)) ? 0 : Number(totalWeight),
            usages: usageList,
            matches: UsageDetailsMapper.mapStateToMatches(state.matchingWorks, state.matchingProducts),
            workflows,
            attachedFiles: UsageDetailsMapper.mapStateToAttachedFiles(files, id),
            location,
            setListAdditional,
            venueDetails,
            moreDates,
            approvalStatus,
            sourceIP,
            qaStatus,
            rejectReason,
            usagePool: UsagePoolDetailsMapper.mapStateToPool(usagePool),
            usageSearch: UsageDetailsMapper.populateUsageSearch(usageList),
            catOne,
            catTwo,
            customerVenues: state.customerVenues,
            createMatchHistory: UsageDetailsMapper.mapHistoryFlagToUsageGroup(
                    matchStatus,
                    createMatchHistory
                ),
            licenses: matchingLicenses,
            comments: commentList,
            setListArtist: UsageDetailsMapper.mapStateToArtists(setListArtist),
        }
        return usageGroup;
    }

    public static populateUsageSearch(usages: IUsage[]): IUsageSearch {
        if (!usages || usages.length === 0) {
            return {
                CarrierType: [''],
                Use: [''],
                Dimension1: [''],
                Dimension2: [''],
                Dimension3: [''],
                Dimension4: [''],
                Dimension5: [''],
                UsageFrom: '',
                UsageTo: '',
                PerformanceNumbers: [],
                InboundFeesInError: false,
                OutboundFeesInError: false
            };
        }

        const getDistinctValues = (field: string): string[] => {
            const values = usages
                .map(u => u[field])
                .filter(val => val !== undefined)
                .map(val => val ?? '');

            return values.length > 0 ? [...new Set(values)] : [''];
        };

        const getAllPerformanceNumbers = (): IPerformanceNumber[] => {
            const allNumbers: IPerformanceNumber[] = [];
            usages.forEach(u => {
                if (u.performanceNumbers && u.performanceNumbers.length > 0) {
                    u.performanceNumbers.forEach(pn => {
                        const exists = allNumbers.some(
                            existing => existing.number === pn.number && existing.typeCode === pn.typeCode
                        );

                        if (!exists) {
                            allNumbers.push({
                                number: pn.number,
                                typeCode: pn.typeCode
                            });
                        }
                    });
                }
            });
            return allNumbers;
        };

        const getMinMaxUsageDates = (): { min: string, max: string } => {
            const validDates = usages
                .map(u => u.usageDate)
                .filter(date => date && typeof date === 'string' && date !== '');

            if (validDates.length === 0) {
                return { min: '', max: '' };
            }

            validDates.sort();
            return {
                min: validDates[0],
                max: validDates[validDates.length - 1]
            };
        };

        const checkFeesInError = (errorType: string): boolean => {
            return usages.some(u =>
                u.usageDetails && u.usageDetails.some(ud => ud[errorType] === true)
            );
        };

        const dates = getMinMaxUsageDates();

        return {
            CarrierType: getDistinctValues('carrierType'),
            Use: getDistinctValues('use'),
            Dimension1: getDistinctValues('dimension1'),
            Dimension2: getDistinctValues('dimension2'),
            Dimension3: getDistinctValues('dimension3'),
            Dimension4: getDistinctValues('dimension4'),
            Dimension5: getDistinctValues('dimension5'),
            UsageFrom: dates.min,
            UsageTo: dates.max,
            PerformanceNumbers: getAllPerformanceNumbers(),
            InboundFeesInError: checkFeesInError('inboundFeesInError'),
            OutboundFeesInError: checkFeesInError('outboundFeesInError')
        };
    }

    public static convertDateFormat(dateString) {
        if (!dateString) {
            return "";
        }
        // MM/DD/YYYY HH:mm:ss
        if (dateString.includes('/')) {
            const [date, time] = dateString.split(' ');
            const [month, day, year] = date.split('/');
            return `${year}-${month}-${day}T${time}`;
        }

        // YYYY-MM-DD HH:mm:ss 
        else if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(dateString)) 
            { 
                dateString = dateString.replace(' ', 'T');
                if (!dateString.endsWith('Z')) { dateString += 'Z'; }
            }
        return dateString;
    }

    public static mapStateToComments(comments: IUsageGroupComment[]) {
        if (comments && comments.length > 0) {
            const newComments = [];
            comments.map(a =>
                newComments.push({
                    comment: a.comment.value,
                    subject: a.subject.value,
                    date: a.date.value,
                    isModified: a?.isModified,
                }));

            return newComments;
        } else {
            return [];
        }
    }

    public static mapStateToArtists(artist: IArtist[]) {
        if (artist && artist.length > 0) {
            const newArtists = [];
            artist.map(a =>
                newArtists.push({
                    type: a.type.value,
                    firstName: a.firstName.value,
                    lastName: a.lastName.value,
                    fullName: a.fullName.value,
                    number: a.number.value,
                    performerID: a.performerID,
                    workPerformerID: a.workPerformerID,
                    performerNumberID: a.performerNumberID,
                    numberType: a.numberType.value,
                }));

            return newArtists;
        } else {
            return [];
        }
    }

    public static mapArtistsToState(artist) {
        if (artist && artist.length > 0) {
            const newArtists = [];
            artist.map(a =>
                newArtists.push({
                    type: { value: a.type },
                    firstName: { value: a.firstName },
                    lastName: { value: a.lastName },
                    fullName: { value: a.fullName },
                    number: { value: a.number },
                    performerID: a.performerID,
                    workPerformerID: a.workPerformerID,
                    performerNumberID: a.performerNumberID,
                    numberType: { value: a.numberType },
                }));

            return newArtists;
        } else {
            return [];
        }
    }

    public static mapCallToComments(comments) {
        if (comments && comments.length > 0) {
            const newComments = [];
            comments.map(a =>
                newComments.push({
                    comment: {
                        value: a.comment,
                        inputType: 'text'

                    },
                    subject: {
                        value: a.subject,
                        inputType: 'text'
                    },
                    date: {
                        value: a.date,
                        inputType: "readonly"
                    },
                    isModified: a?.isModified,
                }));

            return newComments;
        } else {
            return [];
        }
    }

    public static mapStateToUsages(state: IUsageGroupState): IUsage[] {
        const usages: IUsage[] = [];
        state.usages.map(u => {
            const usage: IUsage = {
                id: u.catalogue.value,
                bundle: u.bundle.value,
                bundleRetailPriceExTax: u.bundlePrice.value,
                bundleTracks: "",
                bundleTracksPayable: "",
                carrierType: u.carrierType.value,
                cartNumber: "",
                count: isNaN(parseInt(u.usageCount.value)) ? null : Number(u.usageCount.value),
                distributionMethod: "",
                durationPerPlay: parseFloat(u.durationPerPlay.value),
                inDispute: "",
                musicDuration: null,
                programEndDate: u.programEndDate.value ? u.programEndDate.value : null,
                programName: "",
                programStartDate: u.programStartDate.value ? u.programStartDate.value : null,
                publisher: "",
                receivedAmount: "",
                recordLabel: u.recordLabel.value,
                recordName: "",
                recordingDate: "",
                productionCountry: u.productionCountry.value,
                exploitationSourceIdentifier: u.exploitationSourceIdentifier.value,
                exploitationSourceName: u.exploitationSourceName.value,
                recordingType: "",
                releaseDate: "",
                royaltyAmount: "",
                royaltyAmountPerPerformance: "",
                timing: "",
                trackNumber: "",
                unitRetailPrice: "",
                unitRetailPriceExVat: "",
                usageDate: UsageDetailsMapper.convertDateFormat(u.usageDate.value),
                weight: isNaN(parseFloat(u.weight.value)) ? null : Number(u.weight.value),
                usageDetails: [],
                names: [],
                performanceNumbers: [],
                performers: [],
                contributors: [],
                productDetails: u.productDetails,
                use: u.use.value,
                dimension1: u.dimension1.value,
                dimension2: u.dimension2.value,
                dimension3: u.dimension3.value,
                dimension4: u.dimension4.value,
                dimension5: u.dimension5.value,
                weightingCode: u.weightingCode.value,
                evpp: u.evpp.value,
                evppOverride: u.evppOverride,
                estimatedValue: u.estimatedValue.value,
                countryOfUsage: u.countryOfUsage.value,
                weightMultiplier: u.weightMultiplier.value,
                exploitationTerritoryAbbreviatedName: u.territoryName.value,
                amountForAllocationRule: u.amountForAllocationRule.value,
                isSelected: u.isSelected.value,
                guid: u.guid.value,
                isDeleted: u.isDeleted,
                versionNumber: u.versionNumber.value
            }
            const usageDetails: IUsageDetails[] = [];
            u.usageDetails.map(a =>
                usageDetails.push({
                    remittingSocietyWorkCode: state.remittingSocietyWorkCode,
                    rightOwner: a.name,
                    rightOwnerNationalNumber: a.rightOwnerNationalNumber,
                    rightOwnerIPINameNumber: a.ipiNumber,
                    rightOwnerLicensorsNumber: a.rightOwnerLicensorsNumber,
                    amount: a.amount,
                    currencyCode: a.currencyCode,
                    society: a.society,
                    role: a.role,
                    territoryCode: a.territoryCode,
                    territoryName: a.territoryName,
                    userAdjustment: a.userAdjustment,
                    accountNumber: a.accountNumber,
                    adjustmentNumber: a.adjustmentNumber,
                    adjustmentReasonCode: a.adjustmentReasonCode,
                    adjustmentCommentary: a.adjustmentCommentary,
                    sharePercentage: a.share,
                    additionalInformation: a.additionalInformation,
                    applicableRoyaltyRate: a.applicableRoyaltyRate,
                    royaltyRate: a.royaltyRate,
                    inboundFeesInError: a.inboundFeesInError,
                    outboundFeesInError: a.outboundFeesInError,
                    adjustments: a.adjustments,
                    errorMessage: a.errorMessage
                }));
            const performanceNumbers: IPerformanceNumber[] = [];
            u.performanceNumbers.map(b =>
                performanceNumbers.push({
                    number: b.number,
                    typeCode: b.typeCode
                }));
            usage.usageDetails = usageDetails;
            usage.performanceNumbers = performanceNumbers;
            usages.push(usage);
        });
        return usages;
    }

    public static mapHistoryFlagToUsageGroup(
        matchStatus: string,
        createMatchHistory: boolean
    ): boolean {
        if (
            matchStatus != null && matchStatus.replaceAll(' ', '') === DEFINITE_MATCH &&
            (createMatchHistory == undefined || createMatchHistory == null)
        ) { return true; }

        return createMatchHistory;
    }

    public static mapStateToMatches(matchingWorksRows: IMatchingWorksRowData[], matchingProductsRows: IMatchingProductsRowData[]): IUsageMatch[] {
        if (matchingWorksRows && matchingWorksRows.length > 0) {
            const matches: IUsageMatch[] = [];
            matchingWorksRows.map(a =>
                matches.push({
                    matchSource: a.source.replace(/\s/g, ''),
                    matchType: a.status.replace(/\s/g, ''),
                    id: a.workID,
                    workData: a
                }));

            return matches;
        }
        else if (matchingProductsRows && matchingProductsRows.length > 0) {
            const matches: IUsageMatch[] = [];
            matchingProductsRows.map(a => {
                const { matchType, ...productData } = a;
                matches.push({
                    matchSource: a.source.replace(/\s/g, ''),
                    matchType: a.type === "SET LIST" && a.source === "Portal" ? DEFINITE_MATCH : (matchType || a.status).replace(/\s/g, ''),
                    id: a.productCoreID,
                    productData
                });
            });

            return matches;
        }
        else {
            return [];
        }
    }

    public static getUsageTitle(usageGroup: IUsageGroup): string {
        if (!usageGroup?.fullTitle) {
            return usageGroup?.id ? `New Usage (${usageGroup.id})` : 'New Usage';
        }

        return `${usageGroup.fullTitle} (${usageGroup.id})`;
    }

    public static mapUsageGroupToUsages(usageGroup: IUsageGroup, reGroupIds?: Number[], lookups?: ILookupDictionary): IUsageRowData[] {
        if (!usageGroup.usages)
            return [];
        const usagesState: IUsageRowData[] = [];
        let updatedUsage;
        if (reGroupIds && reGroupIds.length > 0) {
            updatedUsage = usageGroup.usages.filter((_, index) => reGroupIds.includes(index))
        }
        else {
            updatedUsage = usageGroup.usages
        }
        updatedUsage.map((u) => {
            const isNewUsageGroup = !usageGroup?.id || Number(usageGroup?.id) === 0;
            const usageState: IUsageRowData = {
                catalogue: { value: "", inputType: 'row' },
                usageCount: { value: u.count, inputType: isNewUsageGroup ? 'integer' : 'row' },
                amountForAllocationRule: { value: u.amountForAllocationRule?.toString(), inputType: 'row' },
                durationPerPlay: { value: u.durationPerPlay, inputType: isNewUsageGroup ? 'decimal' : 'row' },
                weight: { value: u.weightString, inputType: 'row' },
                distribution: { value: usageGroup.distributionCode, inputType: 'row' },
                bundle: { value: u.bundle, inputType: isNewUsageGroup ? 'text' : 'row' },
                trackPrice: { value: u.unitRetailPriceExVat, inputType: 'row' },
                bundlePrice: { value: u.bundleRetailPriceExTax, inputType: 'row' },
                usageDate: { value: u.usageDate, inputType: isNewUsageGroup ? DATE_INPUT : 'row' },
                fileName: { value: usageGroup.fileName, inputType: 'row' },
                dateLoaded: { value: usageGroup.dateLoaded, inputType: 'row' },
                amount: u.royaltyAmount,
                sendingLicensee: u.publisher,
                recordLabel: { value: u.recordLabel, inputType: 'row' },
                programName: { value: u.programName, inputType: isNewUsageGroup ? 'text' : 'row' },
                performanceNumbers: u.performanceNumbers,
                usageDetails: UsageDetailsMapper.mapUsageToUsagesDetails(u, lookups),
                productDetails: UsageDetailsMapper.mapUsageToProductDetails(u),
                programStartDate: { value: u.programStartDate, inputType: isNewUsageGroup ? DATE_INPUT : 'row' },
                programEndDate: { value: u.programEndDate, inputType: isNewUsageGroup ? DATE_INPUT : 'row' },
                carrierType: { value: u.carrierType, inputType: 'text' },
                use: { value: u.use, inputType: 'text' },
                dimension1: { value: u.dimension1, inputType: 'text' },
                dimension2: { value: u.dimension2, inputType: 'text' },
                dimension3: { value: u.dimension3, inputType: 'text' },
                dimension4: { value: u.dimension4, inputType: 'text' },
                dimension5: { value: u.dimension5, inputType: 'text' },
                weightingCode: { value: u.weightingCode, inputType: 'row' },
                evpp: { value: u.evpp, inputType: 'text' },
                evppOverride: u.evppOverride,
                estimatedValue: { value: u.estimatedValue, inputType: 'text' },
                countryOfUsage: { value: u.countryOfUsage, inputType: 'dropdown' },
                weightMultiplier: { value: u.weightMultiplier, inputType: 'row' },
                exploitationSourceIdentifier: { value: u.exploitationSourceIdentifier, inputType: 'text' },
                exploitationSourceName: { value: u.exploitationSourceName, inputType: 'text' },
                trackNumber: { value: u.trackNumber, inputType: 'row' },
                recordName: { value: u.recordName, inputType: 'row' },
                recordingDate: { value: u.recordingDate, inputType: 'row' },
                additionalInformation: { value: u.usageDetails[0]?.additionalInformation, inputType: 'row' },
                territoryName: { value: u.exploitationTerritoryAbbreviatedName, inputType: 'row' },
                productionCountry: { value: u.productionCountry, inputType: isNewUsageGroup ? 'text' : 'row' },
                isSelected: { value: '', inputType: CHECKBOX_INPUT },
                guid: { value: u.guid, inputType: 'text' },
                versionNumber: { value: u.versionNumber, inputType: 'text' },
                isDeleted: u.isDeleted,
                contributors: u.contributors,
                names: u.names,
            }
            usagesState.push(usageState);
        });
        return usagesState;
    }

    public static mapUsageToProductDetails(usage: IUsage): IUsageProductDetails[] {
        if (!usage.productDetails || usage.productDetails === null)
            return [];

        const usageProductDetails: IUsageProductDetails[] = [];
        usage.productDetails.map(pd => {
            const usageProductDetail: IUsageProductDetails = {
                avIndexNumber: pd.avIndexNumber,
                avWorkCategory: pd.avWorkCategory,
                avWorkTitle: pd.avWorkTitle,
                originalEpisodeTitle: pd.originalEpisodeTitle
            }
            usageProductDetails.push(usageProductDetail);
        });
        return usageProductDetails;
    }

    public static mapUsageToUsagesDetails(usage: IUsage, lookups?: ILookupDictionary): IUsageDetailsRowData[] {
        if (!usage.usageDetails)
            return null;

        const usageDetailsState: IUsageDetailsRowData[] = [];
        let id = 1;
        usage.usageDetails.map(ud => {
            const usageDetailState: IUsageDetailsRowData = {
                ...ud,
                id: id.toString(),
                ipiNumber: ud.rightOwnerIPINameNumber,
                name: ud.rightOwner,
                share: ud.sharePercentage === EMPTY_STRING_VALUE ? "0" : ud.sharePercentage,
                society: ud.society,
                role: ud.role,
                applicableRoyaltyRate: ud.applicableRoyaltyRate === EMPTY_STRING_VALUE ? "0" : ud.applicableRoyaltyRate,
                amount: ud.amount === EMPTY_STRING_VALUE ? "0" : ud.amount,
                licenseRefID: 0,
                royaltyRate: ud.royaltyRate,
                inboundFeesInError: ud.inboundFeesInError === null ? EMPTY_STRING_VALUE : ud.inboundFeesInError,
                outboundFeesInError: ud.outboundFeesInError === null ? EMPTY_STRING_VALUE : ud.outboundFeesInError,
                adjustments: ud.adjustments === null ? [] : UsageDetailsMapper.mapUsagesDetailsToAdjustments(ud.adjustments),
                errorMessage: ud.errorMessage
            }
            const isThereAlreadyAFrom = usageDetailState.adjustments && usageDetailState.adjustments.length > 0 && usageDetailState.adjustments.some(usage => usage.direction === 'From');
            if (usageDetailState.adjustments && usageDetailState.adjustments.length > 0 && !isThereAlreadyAFrom) {
                usageDetailState.adjustments.push({
                    direction: 'From',
                    id: id.toString(),
                    ipiNumber: ud.rightOwnerIPINameNumber,
                    name: ud.rightOwner,
                    accountNumber: ud.accountNumber,
                    societyAffiliation: lookups['Agency']?.lookups?.find(l => l.code === ud.society)?.description || ud.society,
                    share: ud.sharePercentage === EMPTY_STRING_VALUE ? "0" : ud.sharePercentage,
                    applicableRoyaltyRate: ud.applicableRoyaltyRate === EMPTY_STRING_VALUE ? "0" : ud.applicableRoyaltyRate,
                    amount: ud.amount === EMPTY_STRING_VALUE ? "0" : ud.amount,
                    licenseRefID: 0,
                    royaltyRate: ud.royaltyRate,
                    inboundFeesInError: ud.inboundFeesInError === null ? EMPTY_STRING_VALUE : ud.inboundFeesInError,
                    outboundFeesInError: ud.outboundFeesInError === null ? EMPTY_STRING_VALUE : ud.outboundFeesInError,
                    adjustmentSource: null,
                    adjustmentReason: null,
                })
            }
            usageDetailsState.push(usageDetailState);
            id++;
        });
        return usageDetailsState;
    }

    public static mapUsagesDetailsToAdjustments(adjustments: IUsageDetailsAdjustmentsDataItem[]): IUsageDetailsAdjustmentsDataItem[] {
        const adjustmentsState: IUsageDetailsAdjustmentsDataItem[] = [];
        adjustments.map(adj => {
            const adjustmentState: IUsageDetailsAdjustmentsDataItem = {
                direction: adj.direction,
                id: adj.id ? adj.id.toString() : EMPTY_STRING_VALUE,
                ipiNumber: adj.ipiNumber,
                name: adj.name,
                accountNumber: adj.accountNumber,
                societyAffiliation: adj.societyAffiliation,
                share: adj.share,
                applicableRoyaltyRate: adj.applicableRoyaltyRate === EMPTY_STRING_VALUE ? "0" : adj.applicableRoyaltyRate,
                amount: adj.amount === EMPTY_STRING_VALUE ? "0" : adj.amount,
                licenseRefID: adj.licenseRefID ? adj.licenseRefID : 0,
                royaltyRate: adj.royaltyRate === EMPTY_STRING_VALUE ? "0" : adj.royaltyRate,
                inboundFeesInError: adj.inboundFeesInError === null ? EMPTY_STRING_VALUE : adj.inboundFeesInError,
                outboundFeesInError: adj.outboundFeesInError === null ? EMPTY_STRING_VALUE : adj.outboundFeesInError,
                adjustmentSource: adj.adjustmentSource,
                adjustmentReason: adj.adjustmentReason,
            }
            adjustmentsState.push(adjustmentState);
        });
        return adjustmentsState;
    }

    public static mapUsageGroupToMatchingWorks(usageGroup: IUsageGroup, usageType: string): IMatchingWorksRowData[] {
        if (!usageGroup.matches || usageGroup.matches.length <= 0 || usageType.replace(/([A-Z])/g, ' $1').trim() === USAGETOPRODUCT)
            return null;

        const matchingWorks: IMatchingWorksRowData[] = [];

        const searchQuery: IMatchWorksSearchQuery =
        {
            workIDs: usageGroup.matches.map(mw => mw.id),
            title: "",
            number: "",
            artist: "",
            writers: "",
            societyAccountNumber: "",
            workBatchID: "",
            dataSource: REPERTOIRE,
            hasOpenWorkflow: false
        };

        UsageSearchRequests.getWorksByIdList(searchQuery)
            .then((res: IWorksSearchResult[]) => {
                res.forEach((w) => {
                    const match: IUsageMatch = usageGroup.matches.find(x => x.id === w.workID);
                    const matchingWork: IMatchingWorksRowData = {
                        status: startCase(match.matchType),
                        title: w.title,
                        writers: w.writers,
                        publishers: w.publishers,
                        composers: w.publishers.concat(w.writers),
                        performers: w.artists,
                        number: w.number[0],
                        source: startCase(match.matchSource),
                        workID: match.id,
                        createMatchHistory: match.createMatchHistory,
                    }
                    matchingWorks.push(matchingWork);
                });
            });

        return matchingWorks;
    }

    public static mapUsageGroupToMatchingProducts(usageGroup: IUsageGroup, usageType: string): IMatchingProductsRowData[] {
        if (!usageGroup.matches || usageGroup.matches.length <= 0 || usageType.replace(/([A-Z])/g, ' $1').trim() === USAGETOWORK)
            return null;

        const matchingProducts: IMatchingProductsRowData[] = [];

        const searchQuery: IMatchProductsSearchQuery =
        {
            productIDs: usageGroup.matches.map(mw => mw.id),
            title: "",
            number: "",
            artist: "",
            contributor: "",
            productBatchID: "",
            productType: usageGroup?.productType ? usageGroup?.productType : "",
            dataSource: REPERTOIRE,
        };

        UsageSearchRequests.getProducts(searchQuery)
            .then((res: IProductSearchResult[]) => {
                res.forEach((w) => {
                    const match: IUsageMatch = usageGroup.matches.find(x => x.id === w.productCoreID);
                    const matchingProduct: IMatchingProductsRowData = {
                        status: startCase(match.matchType),
                        id1: w.id1,
                        id2: w.id2,
                        artist: w.artist,
                        contributor: w.contributor,
                        productCoreID: w.productCoreID,
                        source: startCase(match.matchSource),
                        title: w.title,
                        episode: w.episode,
                        type: w.type,
                        number: w.number,
                        productionType: w.productionType,
                        musicDuration: w.musicDuration,
                        createMatchHistory: match.createMatchHistory ?? null,
                        yearOfProduction: w.yearOfProduction,
                        worksCount: w.worksCount
                    }
                    matchingProducts.push(matchingProduct);
                });
            });

        return matchingProducts;
    }

    public static mapAttachmentsToFileState(attachments: IAttachedFile[]): IStoragePathItemData[] {
        const files: IStoragePathItemData[] = [];
        if (attachments) {
            attachments.map(file => {
                files.push(
                    {
                        fullName: `repertoireAttachments/usage/${file.guid}`,
                        inProgress: false,
                        isDirectory: false,
                        isDirty: false,
                        isEditing: false,
                        lastModified: file.lastModifiedDate && file.lastModifiedDate.toString(),
                        sources: [],
                        metadata: undefined,
                        name: file.fileName,
                        pools: [],
                        formats: [],
                        distributions: [],
                        validationError: undefined,
                        attachmentTypeID: file.attachmentTypeID,
                        attachmentTypeCode: file.attachmentTypeCode,
                    }
                )
            })
        }
        return files;
    }



    public static mapStateToAttachedFiles(files: IStoragePathItemData[], usageGroupID: string): IAttachedFile[] {
        const attachedFiles: IAttachedFile[] = [];
        if (files) {
            files.map(
                file => {
                    let guid: string = "";
                    const fullNameSplit: string[] = file.fullName.split('/');
                    if (fullNameSplit.length > 2)
                        guid = fullNameSplit[2];

                    attachedFiles.push({
                        fileName: file.name,
                        usageGroupID: usageGroupID,
                        guid: guid,
                        lastModifiedDate: new Date(file.lastModified),
                        attachmentTypeID: file.attachmentTypeID,
                        attachmentTypeCode: file.attachmentTypeCode,
                    })
                }
            )
        }
        return attachedFiles;
    }
    public static createEmptyUsageRow(lookups: ILookupDictionary, distributionCode?: string): IUsageRowData {
        const usageGroup = UsageDetailsMapper.createNewUsage(lookups, distributionCode);
        const [emptyUsageRow] = UsageDetailsMapper.mapUsageGroupToUsages(usageGroup, undefined, lookups);
        return emptyUsageRow;
    }

    public static createNewUsage(lookups: ILookupDictionary, distributionCode?: string, portalType?: string, currentUser?: string): IUsageGroup {


        const usage: IUsageGroup = {
            id: "0",
            fullTitle: "",
            fullContributor: "",
            fullPerformer: "",
            distributionCode: distributionCode || "",
            poolCode: "",
            sourceMajor: "",
            sourceMinor: "",
            usageType: "",
            productType: getLookupDefault(PRODUCT_TYPE_LOOKUP, lookups),
            matchStatus: "",
            allocationStatus: "",
            allocations: null,
            remittingSocietyWorkCode: "",
            dateLoaded: "",
            fileName: "",
            totalWeight: 0,
            isDeleted: false,
            usages: [
                {
                    id: "0",
                    bundle: "",
                    bundleRetailPriceExTax: "",
                    bundleTracks: "",
                    bundleTracksPayable: "",
                    carrierType: "",
                    cartNumber: "",
                    contributors: [],
                    countryOfUsage: null,
                    count: 0,
                    distributionMethod: "",
                    durationPerPlay: 0,
                    inDispute: "",
                    musicDuration: null,
                    names: [],
                    performanceNumbers: [],
                    performers: [],
                    programEndDate: null,
                    programName: "",
                    programStartDate: null,
                    publisher: "",
                    receivedAmount: "",
                    recordLabel: "",
                    recordName: "",
                    recordingDate: "",
                    productionCountry: "",
                    exploitationSourceIdentifier: "",
                    exploitationSourceName: "",
                    recordingType: "",
                    releaseDate: "",
                    royaltyAmount: "",
                    royaltyAmountPerPerformance: "",
                    timing: "",
                    trackNumber: "",
                    unitRetailPrice: "",
                    unitRetailPriceExVat: "",
                    usageDate: "",
                    exploitationTerritoryAbbreviatedName: "",
                    usageDetails: [],
                    weight: 0,
                    productDetails: [],
                    amountForAllocationRule: null,
                    use: "",
                    dimension1: "",
                    dimension2: "",
                    dimension3: "",
                    dimension4: "",
                    dimension5: "",
                    weightingCode: "",
                    isDeleted: false,
                }
            ],
            usagePool: null,
            matches: [],
            workflows: [],
            attachedFiles: [],
            location: null,
            setListAdditional: {
                otherArtistPerform: false,
                performanceType: '',
                promoter: '',
                stage: ''
            },
            venueDetails: {
                firstName: '',
                lastName: '',
                phoneNumber: '',
                venueType: '',
                venueLookupType: '',
                otherTypeOfVenue: ''
            },
            moreDates: [
            ],
            qaStatus: null,
            rejectReason: null,
            usageSearch: {
                CarrierType: [''],
                Use: [''],
                Dimension1: [''],
                Dimension2: [''],
                Dimension3: [''],
                Dimension4: [''],
                Dimension5: [''],
                UsageFrom: '',
                UsageTo: '',
                PerformanceNumbers: [],
                InboundFeesInError: false,
                OutboundFeesInError: false
            }
        }


        usage.createdBy = portalType === MEMBERS_PORTAL ? null : currentUser;
        return usage;
    }


    public static createNewUsageState(lookups: ILookupDictionary, distributionCode?: string, currentUserNameNumber?: number, portalType?: string, currentUser?: string): IUsageGroupState {
        let usageGroup = UsageDetailsMapper.createNewUsage(lookups, distributionCode, portalType, currentUser);
        if (currentUserNameNumber) {
            usageGroup.sourceIP = currentUserNameNumber;
            usageGroup.productType = "SET LIST";
        }
        return UsageDetailsMapper.mapUsageToState(usageGroup)
    }

}
